/**
 * ████████╗ ██████╗ ██╗     ██╗███╗   ██╗ ██████╗
 * ╚══██╔══╝██╔═══██╗██║     ██║████╗  ██║██╔═══██╗
 *    ██║   ██║   ██║██║     ██║██╔██╗ ██║██║   ██║
 *    ██║   ██║   ██║██║     ██║██║╚██╗██║██║   ██║
 *    ██║   ╚██████╔╝███████╗██║██║ ╚████║╚██████╔╝
 *    ╚═╝    ╚═════╝ ╚══════╝╚═╝╚═╝  ╚═══╝ ╚═════╝
 *
 * (c) Copyright 2022-present Rakuten Kobo Inc. (https://www.kobo.com)
 */

// -----------------------------------------------------------------------------
// SERVICE REGISTRATION
// -----------------------------------------------------------------------------

//service config for service locator
export const config = ["sessionStorage", [], createSessionStorageService];

// -----------------------------------------------------------------------------
// PRIVATE MODULE METHODS
// -----------------------------------------------------------------------------

// -----------------------------------------------------------------------------
// Session Storage SERVICE
// -----------------------------------------------------------------------------

/**
 * Factory function which creates a service with given
 * dependencies
 *
 * Storage object for the current origin. sessionStorage is
 * similar to localStorage; the difference is that while data
 * in localStorage doesn't expire, data in sessionStorage is
 * cleared when the page session ends.
 *
 * @see https://developer.mozilla.org/en-US/docs/Web/API/Window/sessionStorage
 */
export function createSessionStorageService() {


  function getItem(key) {
    return window.sessionStorage.getItem(key);
  }

  function setItem(key, value) {
    return window.sessionStorage.setItem(key, value);
  }

  function removeItem(key) {
    return window.sessionStorage.removeItem(key);
  }



  // ---------------------------------------------------------------------------
  // PUBLIC API
  // ---------------------------------------------------------------------------

  return {
    getItem,
    setItem,
    removeItem
  };
}
